<template>
	<BaseLoading v-if="isLoading" />
	<div v-else>
		<FormUserRolePermissionSetting
			:is-submitting="create.isCreating"
			:permissions="permissions.data"
			:pdpa="pdpa.data"
			@onConfirm="handleConfirm"
		/>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormUserRolePermissionSetting from '@/components/FormUserRolePermissionSetting.vue';

export default {
	name: 'UserRoleCreate',
	components: {
		FormUserRolePermissionSetting,
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		...mapState('roles', {
			create: 'create',
			permissions: 'permissions',
			pdpa: 'pdpa',
		}),
	},
	async created() {
		this.isLoading = true;
		await Promise.all([
			this.getPermissions(),
			this.getPdpaList(),
		]);
		this.isLoading = false;
	},
	methods: {
		...mapActions({
			getPermissions: 'roles/getPermissions',
			getPdpaList: 'roles/getPdpaList',
			createRole: 'roles/createRole',
		}),
		async handleConfirm(formData) {
			const params = {
				...formData,
			};
			await this.createRole(params);
		},
	},
};
</script>
